<template>
  <v-container fluid fill-height grid-list-md>
    <v-layout justify-center wrap>
      <v-flex xs12 sm10 md10>
        <v-card class="elevation-4">
          <v-toolbar dark color="primary" flat>
            <v-toolbar-title>Tambah Member</v-toolbar-title>
          </v-toolbar>
          <v-card-text>
            <v-form>
              <v-text-field
                placeholder="Masukkan Nama Lengkap Member"
                outlined
                label="Nama Lengkap"
                type="text"
                v-model="fullName"
              ></v-text-field>
              <v-text-field
                placeholder="Masukkan Nomor Identitas"
                outlined
                label="Nomor Identitas"
                type="text"
                v-model="idNumber"
              ></v-text-field>
              <v-radio-group v-model="gender">
                <template v-slot:label>
                  <div>Gender</div>
                </template>
                <v-radio value="MAN">
                  <template v-slot:label>
                    <div>Pria</div>
                  </template>
                </v-radio>
                <v-radio value="WOMAN">
                  <template v-slot:label>
                    <div>Wanita</div>
                  </template>
                </v-radio>
              </v-radio-group>
              <v-layout>
                <v-flex xs12 md6 class="mb-8">
                  <v-menu
                    ref="menu1"
                    v-model="menu1"
                    :close-on-content-click="false"
                    transition="scale-transition"
                    offset-y
                    full-width
                    max-width="290px"
                    min-width="290px"
                  >
                    <template v-slot:activator="{ on }">
                      <v-text-field
                        label="Tanggal Lahir"
                        hint="Tanggal lahir member"
                        persistent-hint
                        prepend-icon="event"
                        v-on="on"
                        readonly
                        :value="birthDateFormatted"
                      ></v-text-field>
                    </template>
                    <v-date-picker
                      v-model="birthDate"
                      :max="new Date().toISOString().substr(0, 10)"
                      ref="birthDatePicker"
                      @input="menu1 = false"
                    ></v-date-picker>
                  </v-menu>
                </v-flex>
              </v-layout>
            </v-form>
          </v-card-text>
        </v-card>
      </v-flex>

      <v-flex xs12 sm10 md10>
        <v-card class="elevation-4">
          <v-toolbar color="white" flat>
            <v-toolbar-title>Foto</v-toolbar-title>
          </v-toolbar>
          <v-card-text>
            <v-form>
              <v-file-input
                label="Foto Member"
                placeholder="Pilih Foto Member"
                outlined
                accept="image/*"
                v-model="memberImage"
                @change="onFileChange"
                persistent-hint
                hint="Foto untuk profile member"
              ></v-file-input>
              <v-img
                max-height="125"
                class="text-left"
                contain
                :src="imagePath"
              >
              </v-img>
            </v-form>
          </v-card-text>
        </v-card>
      </v-flex>

      <v-flex xs12 sm10 md10>
        <v-card class="elevation-4">
          <v-toolbar color="white" flat>
            <v-toolbar-title>Alamat</v-toolbar-title>
          </v-toolbar>
          <v-card-text>
            <v-form>
              <v-text-field
                placeholder="Masukkan Kabupaten/Kota"
                outlined
                label="Kabupaten/Kota"
                type="text"
                v-model="kabupaten"
              ></v-text-field>
              <v-text-field
                placeholder="Masukkan Kecamatan"
                outlined
                label="Kecamatan"
                type="text"
                v-model="kecamatan"
              ></v-text-field>
              <v-text-field
                placeholder="Masukkan Kelurahan"
                outlined
                label="Kelurahan"
                type="text"
                v-model="kelurahan"
              ></v-text-field>
              <v-text-field
                placeholder="Masukkan Kota"
                outlined
                label="Kota"
                type="text"
                v-model="kota"
                v-show="false"
              ></v-text-field>
              <v-layout wrap>
                <v-flex xs12 md3>
                  <v-text-field
                    placeholder="Masukkan RT"
                    outlined
                    label="RT"
                    type="text"
                    v-model="rt"
                  ></v-text-field>
                </v-flex>
                <v-flex xs12 md3>
                  <v-text-field
                    placeholder="Masukkan RW"
                    outlined
                    label="RW"
                    type="text"
                    v-model="rw"
                  ></v-text-field>
                </v-flex>
              </v-layout>
              <v-layout wrap>
                <v-flex xs12 md4>
                  <v-text-field
                    placeholder="Masukkan Kode Pos"
                    outlined
                    label="Kode Pos"
                    type="text"
                    v-model="kodepos"
                  ></v-text-field>
                </v-flex>
              </v-layout>
              <v-textarea
                label="Alamat Lengkap"
                outlined
                placeholder="Masukkan Alamat Lengkap"
                persistent-hint
                hint="detail alamat seperti nama jalan atau nomor rumah"
                v-model="alamatLengkap"
              ></v-textarea>
            </v-form>
          </v-card-text>
        </v-card>
      </v-flex>

      <v-flex xs12 sm10 md10>
        <v-card class="elevation-4">
          <v-toolbar color="white" flat>
            <v-toolbar-title>Kontak</v-toolbar-title>
          </v-toolbar>
          <v-card-text>
            <v-form>
              <v-text-field
                placeholder="Masukkan Nomor HP"
                outlined
                label="Nomor HP"
                type="text"
                v-model="mobilePhone"
              ></v-text-field>
              <v-text-field
                placeholder="Masukkan No. Telepon"
                outlined
                label="No. Telepon"
                type="text"
                v-model="phone"
              ></v-text-field>
              <v-text-field
                placeholder="Masukkan E-mail"
                outlined
                label="E-mail"
                type="text"
                v-model="email"
              ></v-text-field>
            </v-form>
          </v-card-text>
        </v-card>
      </v-flex>

      <v-flex xs12 sm10 md10>
        <v-card class="elevation-4">
          <v-toolbar color="white" flat>
            <v-toolbar-title>Lainnya</v-toolbar-title>
          </v-toolbar>
          <v-card-text>
            <v-form>
              <v-select
                v-model="religion"
                :items="religions"
                item-text="label"
                item-value="value"
                menu-props="auto"
                label="Agama"
                outlined
                placeholder="Agama"
              ></v-select>
              <v-text-field
                placeholder="Masukkan Pekerjaan"
                outlined
                label="Pekerjaan"
                type="text"
                v-model="job"
              ></v-text-field>
              <v-select
                v-model="education"
                :items="educations"
                item-text="label"
                item-value="value"
                menu-props="auto"
                outlined
                placeholder="Pendidikan Terakhir"
                label="Pendidikan Terakhir"
              ></v-select>
            </v-form>
          </v-card-text>
          <v-card-actions>
            <v-container fluid fill-height>
              <v-layout wrap justify-start>
                <v-flex xs12>
                  <v-divider light></v-divider>
                </v-flex>
                <v-flex xs12 class="text-right">
                  <v-btn color="tertiary" class="mr-4" dark :to="mainPath"
                    >Kembali</v-btn
                  >
                  <v-btn
                    color="secondary"
                    :loading="loading"
                    :disabled="loading"
                    @click="addData"
                    >Tambah<template v-slot:loader>
                      <span class="custom-loader">
                        <v-icon light>cached</v-icon>
                      </span>
                    </template></v-btn
                  >
                </v-flex>
              </v-layout>
            </v-container>
          </v-card-actions>
        </v-card>
      </v-flex>
    </v-layout>
    <v-snackbar
      v-model="isLoadingFinished"
      top
      :color="loadingMessageColor"
      :timeout="errorTimeout"
    >
      <span v-html="loadingMessage"></span>
      <v-btn dark text @click="isLoadingFinished = false">
        Close
      </v-btn>
    </v-snackbar>
  </v-container>
</template>

<script>
export default {
  data() {
    return {
      loading: false,
      isLoadingFinished: false,
      loadingMessage: null,
      loadingMessageColor: "primary",
      errorTimeout: 7000,
      mainPath: process.env.VUE_APP_MEMBER_PATH,
      religionPath: process.env.VUE_APP_RELIGION_PATH,
      educationPath: process.env.VUE_APP_EDUCATION_PATH,
      fullName: null,
      idNumber: null,
      gender: null,
      birthDate: null,
      menu1: null,
      kabupaten: null,
      kecamatan: null,
      kelurahan: null,
      kota: null,
      rt: null,
      rw: null,
      kodepos: null,
      alamatLengkap: null,
      mobilePhone: null,
      phone: null,
      email: null,
      religion: null,
      job: null,
      education: null,
      imagePath: "",
      memberImage: [],
      religions: [],
      educations: []
    };
  },
  watch: {
    menu1(val) {
      val &&
        setTimeout(() => (this.$refs.birthDatePicker.activePicker = "YEAR"));
    }
  },
  methods: {
    addData() {
      this.loading = true;
      this.isLoadingFinished = false;
      let self = this;
      let formData = new FormData();
      if (self.memberImage) {
        formData.append("memberImage", self.memberImage);
      }
      formData.append(
        "memberMainData",
        new Blob(
          [
            JSON.stringify({
              fullName: self.fullName,
              idNumber: self.idNumber,
              gender: self.gender,
              birthDate: self.birthDateFormatted,
              kabupaten: self.kabupaten,
              kecamatan: self.kecamatan,
              kelurahan: self.kelurahan,
              kota: self.kota,
              rt: self.rt,
              rw: self.rw,
              kodepos: self.kodepos,
              alamatLengkap: self.alamatLengkap,
              mobilePhone: self.mobilePhone,
              phone: self.phone,
              email: self.email,
              religion: self.religion,
              job: self.job,
              education: self.education
            })
          ],
          {
            type: "application/json"
          }
        )
      );

      this.axios
        .post(self.mainPath, formData, {
          headers: { "Content-Type": "multipart/form-data" }
        })
        .then(function() {
          self.loadingMessage =
            "Sukses mendaftarkan member <b>" + self.fullName + "</b>";
          self.loadingMessageColor = "primary";
          self.$vuetify.goTo(0, self.successScrollOptions);
        })
        .catch(function(error) {
          if (error.response) {
            self.loadingMessage = error.response.data.message;
          } else {
            self.loadingMessage = error;
          }
          self.loadingMessageColor = "error";
        })
        .finally(function() {
          self.loading = false;
          self.isLoadingFinished = true;
        });
    },
    fetchReligions() {
      let self = this;
      this.axios
        .get(self.religionPath)
        .then(function(response) {
          self.religions = response.data;
        })
        .catch(function(error) {
          if (error.response) {
            self.loadingMessage = error.response.data.message;
          } else {
            self.loadingMessage = error;
          }
          self.loadingMessageColor = "error";
          self.isLoadingFinished = true;
        });
    },
    fetchEducations() {
      let self = this;
      this.axios
        .get(self.educationPath)
        .then(function(response) {
          self.educations = response.data;
        })
        .catch(function(error) {
          if (error.response) {
            self.loadingMessage = error.response.data.message;
          } else {
            self.loadingMessage = error;
          }
          self.loadingMessageColor = "error";
          self.isLoadingFinished = true;
        });
    },
    onFileChange(e) {
      var reader = new FileReader();
      reader.onload = e => {
        this.imagePath = e.target.result;
      };
      reader.readAsDataURL(e);
    }
  },
  computed: {
    successScrollOptions() {
      return {
        duration: 1000,
        offset: 0,
        easing: "easeInOutCubic"
      };
    },
    birthDateFormatted() {
      return this.birthDate
        ? this.$moment(this.birthDate).format("DD-MM-YYYY")
        : "";
    }
  },
  mounted: function() {
    this.fetchReligions();
    this.fetchEducations();
  }
};
</script>

<style>
.custom-loader {
  animation: loader 1s infinite;
  display: flex;
}
@-moz-keyframes loader {
  from {
    transform: rotate(0);
  }
  to {
    transform: rotate(360deg);
  }
}
@-webkit-keyframes loader {
  from {
    transform: rotate(0);
  }
  to {
    transform: rotate(360deg);
  }
}
@-o-keyframes loader {
  from {
    transform: rotate(0);
  }
  to {
    transform: rotate(360deg);
  }
}
@keyframes loader {
  from {
    transform: rotate(0);
  }
  to {
    transform: rotate(360deg);
  }
}
</style>
